export default "__VITE_ASSET__B6TLyEBu__"